import { useTranslation } from 'react-i18next'

import { FormPassengersValues } from 'entities/ticket/models/form-passengers'

import { preparePhoneNumberForRequest } from 'shared/lib/prepare-phone-number'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface Props {
  formPassengers: FormPassengersValues | null
}

export const ContactPassenger = ({ formPassengers }: Props) => {
  const { t } = useTranslation()

  if (!formPassengers) return null

  return (
    <div className={s.container}>
      <Paper padding={[16]}>
        <p className={s.buyer}>{t('buyer')}</p>

        {formPassengers?.email && (
          <div className={s.block}>
            <span className={s.subTitle}>{t('email')}</span>

            <p className={s.title}>{formPassengers?.email}</p>
          </div>
        )}

        <div className={s.block}>
          <span className={s.subTitle}>{t('purchase_page.phone_number')}</span>

          <p className={s.title}>
            {preparePhoneNumberForRequest(formPassengers?.phone_number)}
          </p>
        </div>
      </Paper>
    </div>
  )
}
